import ErrorManager from '@/common/utils/ErrorManager';
import BillingWidgetItems from '@/models/BillingWidgetItems';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import { RootState } from '@/plugins/store';
import { ActionTree, Commit, MutationTree } from 'vuex';
import HomeService from '../../services/HomeService';
import { BILLING_WIDGET } from '../mutation-types';

export interface WidgetFacturesState{
    billingItems: BillingWidgetItems
    isLoading: boolean
    error: boolean
}

interface PreventiveOutActionType{
    commit: Commit
    state: WidgetFacturesState
}

export enum BillingAction {
    GET_BILLING_DATA = 'GET_BILLING_DATA',
}

const initialState = (): WidgetFacturesState => ({
    billingItems: {
        nbEnRetard: 0,
        nbEnAttente: 0,
        nbMaxJourRetard: 0,
        nbPayees: 0,
    },
    isLoading: false,
    error: false
});

const actions: ActionTree<WidgetFacturesState, RootState>  = {
    async [BillingAction.GET_BILLING_DATA]({ commit}: PreventiveOutActionType) : Promise<void> {
        commit(BILLING_WIDGET.SET_LOADING, true);
        HomeService.getBillingData().then(async response =>{
            if(response !== undefined || response.status !== undefined) {
                if(response.status !== 200){
                    commit(BILLING_WIDGET.SET_ERROR, true);
                    commit(BILLING_WIDGET.SET_LOADING, false);
                    commit(`errorToaster/${ERROR.SET_MESSAGE}`,await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'), {root: true});
                }
                const billingData: BillingWidgetItems = response.data;
                commit(BILLING_WIDGET.SET_ITEMS, billingData);
                commit(BILLING_WIDGET.SET_LOADING, false);
            }else{
                commit(BILLING_WIDGET.SET_ERROR, true);
                commit(BILLING_WIDGET.SET_LOADING, false);
                commit(`errorToaster/${ERROR.SET_MESSAGE}`,await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'), {root: true});
            }
        }).catch(async error =>{
            commit(BILLING_WIDGET.SET_ERROR, true);
            commit(BILLING_WIDGET.SET_LOADING, false);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`,await ErrorManager.processError(error), {root: true});
        });
    }
};

const mutations: MutationTree<WidgetFacturesState> = {
    [BILLING_WIDGET.SET_LOADING](state: WidgetFacturesState, isLoading: boolean) :void {
        state.isLoading = isLoading;
    },
    [BILLING_WIDGET.SET_ERROR](state: WidgetFacturesState, error: boolean) :void {
        state.error = error;
    },
    [BILLING_WIDGET.SET_ITEMS](state: WidgetFacturesState, items: BillingWidgetItems) :void {
        state.billingItems = items;
    },
    [BILLING_WIDGET.RESET](state: WidgetFacturesState) :void {
        Object.assign(state, initialState());
    },
};
const billing = {
    namespaced: true,
    state: initialState,
    actions,
    mutations
};
export default billing;
